module.exports = __webpack_public_path__ + "img/835db5a.jpg";